import { FormattedMessage } from "react-intl";

const AsianEventScreen1x2Header = (): React.JSX.Element => (
  <div className="asian-event-screen-market-headers-wrapper">
    <div className="asian-event-screen-market-headers--period-types">
      <FormattedMessage tagName="span" id="events-phase-FT" />
      <FormattedMessage tagName="span" id="events-phase-HT" />
    </div>
    <div className="asian-event-screen-market-headers">
      <div className="asian-event-screen-market-headers--market-types oneXTwo">
        <div className="col time">
          <FormattedMessage tagName="span" id="global-events-time" />
        </div>
        <div className="col event">
          <FormattedMessage tagName="span" id="global-events-event" />
        </div>
        <div className="oneXTwo-col ft">
          <FormattedMessage tagName="span" id="markets-one" />
          <FormattedMessage tagName="span" id="markets-x" />
          <FormattedMessage tagName="span" id="markets-two" />
        </div>
        <div className="oneXTwo-col ht">
          <FormattedMessage tagName="span" id="markets-one" />
          <FormattedMessage tagName="span" id="markets-x" />
          <FormattedMessage tagName="span" id="markets-two" />
        </div>
      </div>
    </div>
  </div>
);

export default AsianEventScreen1x2Header;
